import React from 'react';
import { Select, Pagination,InputNumber } from '@arco-design/web-react';
export default function HomePagination({ currentPage, pageSize, total, setCurrentPage, setPageSize }) {
   // 计算最大页数
   const maxPage = Math.max(1, Math.ceil(total / pageSize));

   // 跳转页码输入框的处理
   const handleJump = (value) => {
     // 只允许跳转到合法页码
     if (value >= 1 && value <= maxPage) {
       setCurrentPage(value);
     }
   }; 
  return (
    <div style={{ display: 'flex', alignItems: 'center',marginRight: -14}}>
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={total}
        showTotal
        showJumper
        onPageSizeChange={setPageSize}
        onChange={(page, newPageSize) => {
          setCurrentPage(page);
          // 只有当页大小真正改变时才更新
          if (newPageSize !== pageSize) {
            setPageSize(newPageSize);
          }
        }}
      />
      <Select
        style={{ width: 120, marginLeft: 16,marginRight: 16 }}
        value={pageSize}
        onChange={v => { setPageSize(v); }}
        options={[5, 10, 20].map(v => ({ label: `${v} 条/页`, value: v }))}
      />
    </div>
  );
}